import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  setFilterText: ['text'],
  fetchUserList: ['offset', 'onError', 'onNotFound', 'shouldShowError'],
  fetchUserListSuccess: [
    'offset',
    'users',
    'nextOffset',
    'newUser',
    'usersCount',
    'index',
    'filter',
  ],
  setUserListSelectedIndex: ['index'],
  fetchUserListError: ['error'],
  fetchUserListLoading: null,
  clearUsers: null,
  setUsersFilter: ['newFilter'],
  setSelectedCountry: ['newCountry'],
  fetchUserTransactionList: ['userId', 'filter', 'offset', 'shouldShowError'],
  fetchUserTransactionListLoading: null,
  fetchUserTransactionListSuccess: [
    'offset',
    'transactions',
    'nextOffset',
    'pointsTariff',
  ],
  fetchUserTransactionListFail: ['error'],
  clearTransactions: null,

  fetchUserPaymentSessionList: [
    'userId',
    'filter',
    'offset',
    'shouldShowError',
  ],
  fetchUserPaymentSessionListLoading: null,
  fetchUserPaymentSessionListSuccess: [
    'offset',
    'paymentSessions',
    'nextOffset',
  ],
  fetchUserPaymentSessionListError: ['error'],
  clearPaymentSessions: null,

  setUserTransactionsFilter: ['newFilter'],
  clearUserTransactionsFilter: ['admin'],

  setUserPaymentsFilter: ['newFilter'],
  clearUserPaymentsFilter: ['admin'],

  fetchUserDetails: ['userId', 'onNotFound', 'disableSkeleton'],
  fetchUserDetailsSuccess: ['user'],
  fetchUserDetailsFail: ['error'],
  fetchUserDetailsLoading: null,
  clearCurrentUser: null,

  setCurrentUserChargingTokenDeactiveLoading: ['index'],
  setCurrentUserChargingTokenActive: ['userId', 'chargingTokenId', 'index'],
  setCurrentUserChargingTokenDeactiveSuccess: ['index'],
  setCurrentUserChargingTokenDeactiveFail: ['index'],

  setUserSortingAsc: ['isAsc'],
  setSelectedUserIndex: ['index'],

  setCurrentUserTransactionRefundLoading: ['index'],
  setCurrentUserTransactionRefund: ['id', 'index'],
  setCurrentUserTransactionRefundSuccess: ['index'],
  setCurrentUserTransactionRefundFail: ['index'],

  setCurrentUserNewBalance: ['id', 'amount', 'country'],
  setCurrentUserNewBalanceSuccess: ['transaction'],
  setCurrentUserNewBalanceFail: null,
  setCurrentUserNewBalanceLoading: null,

  addCurrentUserNewCard: ['id', 'serialNumbers', 'onError'],
  addCurrentUserNewCardSuccess: ['chargingToken'],
  addCurrentUserNewCardFail: ['error'],
  addCurrentUserNewCardLoading: null,

  toggleCurrentUserIsActive: ['id', 'setIsActive'],
  toggleCurrentUserIsActiveFail: null,
  toggleCurrentUserIsActiveLoading: null,
  toggleCurrentUserIsActiveSuccess: ['id', 'setIsActive'],

  setCurrentUserNewPhone: ['id', 'newPhone'],
  setCurrentUserNewPhoneSuccess: ['id', 'newPhone'],
  setCurrentUserNewPhoneFail: ['id'],
  setCurrentUserNewPhoneLoading: null,

  setCurrentUserEmail: ['id', 'email', 'isEmailVerified', 'onError'],
  setCurrentUserEmailSuccess: ['email', 'isEmailVerified'],
  setCurrentUserEmailFail: null,
  setCurrentUserEmailLoading: null,

  resendCurrentUserEmailVerification: ['id'],
  resendCurrentUserEmailVerificationSuccess: null,
  resendCurrentUserEmailVerificationFail: null,
  resendCurrentUserEmailVerificationLoading: null,

  fetchUserPoints: ['id', 'offset', 'country'],
  fetchUserPointsError: null,
  fetchUserPointsLoading: null,
  fetchUserPointsSuccess: ['offset', 'points', 'nextOffset'],
  clearPoints: null,

  fetchUserListCount: ['filter'],
  fetchUserListCountLoading: null,
  fetchUserListCountSuccess: ['usersCount'],
  fetchUserListCountFail: ['error'],

  deleteCurrentUserPaymentCard: ['userId', 'paymentCardId', 'index'],
  deleteCurrentUserPaymentCardLoading: ['index'],
  deleteCurrentUserPaymentCardSuccess: ['index'],
  deleteCurrentUserPaymentCardFail: ['index'],

  fetchAdminActionsUsersList: ['userId', 'filter', 'offset', 'shouldShowError'],
  fetchAdminActionsLoading: null,
  fetchAdminActionsSuccess: ['offset', 'adminActions', 'nextOffset'],
  fetchAdminActionsError: ['error'],

  clearAdminActionsFilterUser: null,
  setAdminActionsFilterUser: ['newFilter'],
  clearAdminActionsUser: null,
  setAdminActionsPaginationOffsetUser: ['newOffset'],
  setUserTransactionsPaginationOffset: ['newOffset'],
  setUserPaymentsPaginationOffset: ['newOffset'],

  fetchOngoingSessionsList: ['userId'],
  fetchOngoingSessionsListLoading: null,
  fetchOngoingSessionsListSuccess: ['sessions'],
  fetchOngoingSessionsListFail: ['error'],

  fetchUserNotificationList: ['userId', 'filter', 'offset', 'shouldShowError'],
  fetchUserNotificationListLoading: null,
  fetchUserNotificationListSuccess: ['offset', 'notifications', 'nextOffset'],
  fetchUserNotificationListError: ['error'],
  clearNotifications: null,
  setUserNotificationsFilter: ['newFilter'],
  clearUserNotificationsFilter: ['admin'],
  setUserNotificationsPaginationOffset: ['newOffset'],

  fetchTransactionTimeline: ['userId', 'transactionId'],
  fetchTransactionTimelineLoading: null,
  fetchTransactionTimelineSuccess: ['start', 'end', 'notifications'],
  fetchTransactionTimelineError: ['error'],
  clearTransactionTimeline: null,
})

export const UserTypes = Types
export default Creators
